/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_DeleteInputs */

const en_student_delete = /** @type {(inputs: Student_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete student`)
};

const he_student_delete = /** @type {(inputs: Student_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיקת תלמיד`)
};

/**
* | output |
* | --- |
* | "Delete student" |
*
* @param {Student_DeleteInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_delete = /** @type {((inputs?: Student_DeleteInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_DeleteInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_delete(inputs)
	return he_student_delete(inputs)
});